<template>
    <tr>
        <th colspan="4" class="py-5 text-center text-muted">
            <i class="bi bi-archive h1"></i>
            <p>No tienes presupuestos almacenados en el dispositivo.</p>    
        </th>
    </tr>
</template>